import '.d{display:flex;}.ssr-plugin'
import '.a3{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.fp{padding:0.75rem;}.ssr-plugin'
import '.at{border-radius:1.25rem;}.ssr-plugin'
import '.u{border:var(--border-subtle);}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.dn{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fu{width:2.5rem;}.ssr-plugin'
import '.ct{height:2.5rem;}.ssr-plugin'
import '.hh{color:var(--palette-blue-700);}.ssr-plugin'
import '.hi{font-size:0.9rem;}.ssr-plugin'
import '.a8{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d a3 e r s z fp at u t dn"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="fu ct d r a3 hh"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hi hh a8"
        >
          {label}
        </span>
      </styled.button>
    )
}